import fetch from "../interceptor/fetchInterceptor";

export function getAllUsers() {
    return fetch({
        url: "/admin/users",
        method: "get",
        headers: {
            "public-request": "true",
        },
    });
}

export function getChatMessages(id) {
    return fetch({
        url: `/user/chats/${id}`,
        method: "get",
        headers: {
            "public-request": "true",
        },
    });
}

export function changeRideStatus(passData) {
    return fetch({
        url: `/admin/ride/status`,
        method: "post",
        headers: {
            "public-request": "true",
        },
        data: passData,
    });
}

export function chatList() {
    return fetch({
        url: `/user/chat-list`,
        method: "get",
        headers: {
            "public-request": "true",
        },
    });
}

export function markSeenAllMessages(data) {
    return fetch({
        url: `/user/chats/mark-seen`,
        method: "post",
        headers: {
            "public-request": "true",
        },
        data: data,
    });
}
